import type {AnswerModel} from '../../../../../core/domain/Answer/Answer.model';
import type {CromModel} from '../../domain/Crom/Crom.model';

export abstract class SendCromAnswersCommand {
  abstract sendAnswers(
    dto: SendCromAnswersCommand.Params,
  ): SendCromAnswersCommand.Response;
}

export namespace SendCromAnswersCommand {
  export type Params = {
    answersByQuestionId: Map<string, AnswerModel>;
    cromId: string;
  };

  export type Response = Promise<CromModel>;
}
